export default "__VITE_ASSET__DhTbeT1n__"